import { ErrorProps } from '@components/sources/visualizer/mappingScreens/errorsView';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import React from 'react';
import { Config } from '..';
import ModelSelector from './modelSelector';
import S3 from './s3';
import TableSelector from './tableSelector';

export interface IColumn<T = string> {
  name: string;
  type?: T;
}

export interface ConfigEditorProps<T> {
  defaultValue?: T;
  onChangeConfig: (conf: Partial<T>, hardUpdate?: boolean) => void;
  accountId: string;
  onChangeColumns: (cols: IColumn[] | string[]) => void;
  onChangeLoadingState?: (loading: boolean) => void;
  isViewOrUpdate: boolean;
  columnsAsObject?: boolean;
  mappedToDestination?: boolean;
}
interface SourceSpecificConfigEditorProps extends ConfigEditorProps<Config> {
  config: Partial<Config>;
  skipSchemaConfiguration: boolean;
  sourceDefinition: ISourceDefinition;
  updateSchemaErrors: (errorItems: ErrorProps[]) => void;
}

const SourceSpecificConfigEditor: React.FC<SourceSpecificConfigEditorProps> = ({
  defaultValue,
  onChangeConfig,
  accountId,
  onChangeColumns,
  config,
  sourceDefinition,
  skipSchemaConfiguration,
  onChangeLoadingState,
  isViewOrUpdate,
  columnsAsObject,
  mappedToDestination,
  updateSchemaErrors,
}: SourceSpecificConfigEditorProps) => {
  const tableOrSqlModel =
    accountId && !config.sqlModelId ? (
      <TableSelector
        onChangeLoadingState={onChangeLoadingState}
        onChangeConfig={(tableConfig) => onChangeConfig({ ...tableConfig, sqlModelId: undefined })}
        onChangeColumns={onChangeColumns}
        role={sourceDefinition.name}
        accountId={accountId}
        defaultValue={defaultValue}
        config={config}
        isViewOrUpdate={isViewOrUpdate}
        updateSchemaErrors={updateSchemaErrors}
        columnsAsObject={columnsAsObject}
        mappedToDestination={mappedToDestination}
      />
    ) : (
      <ModelSelector
        onChangeLoadingState={onChangeLoadingState}
        onChangeConfig={(modelConfig) =>
          onChangeConfig({ ...modelConfig, table: undefined, schema: undefined })
        }
        onChangeColumns={onChangeColumns}
        role={sourceDefinition.name}
        accountId={accountId}
        defaultValue={defaultValue}
        isViewOrUpdate={isViewOrUpdate}
        updateSchemaErrors={updateSchemaErrors}
        mappedToDestination={mappedToDestination}
      />
    );

  return skipSchemaConfiguration ? (
    <S3
      onChangeLoadingState={onChangeLoadingState}
      onChangeConfig={onChangeConfig}
      onChangeColumns={onChangeColumns}
      role={sourceDefinition.name}
      accountId={accountId}
      defaultValue={defaultValue}
      config={config}
      isViewOrUpdate={isViewOrUpdate}
      columnsAsObject={columnsAsObject}
      mappedToDestination={mappedToDestination}
    />
  ) : (
    tableOrSqlModel
  );
};

export default SourceSpecificConfigEditor;
